import { TenantStorageType } from './types';
import { IShellDAO } from '../../dao/IShellDAO';
import { AbstractRepository } from '../../core/repositories/AbstractRepository';
import { internalLogger } from '../../interface/v1/clientOsLogger';

type TenantDAOItemType = {
  key: string;
  value: TenantStorageType;
};

export class TenantRepository extends AbstractRepository<TenantStorageType> {
  constructor({
    shellDAO,
    enableSanitizer = false
  }: {
    shellDAO: IShellDAO;
    enableSanitizer?: boolean;
  }) {
    super({
      shellDAO: shellDAO,
      prefixKey: 'jshellTenant',
      enableSanitizer
    });
  }

  saveAll(): void {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'TenantRepository',
      methodName: 'saveAll()',
      message: 'Not supported in TenantRepository.'
    });
    throw new Error('Method not implemented.');
  }

  findAll(): TenantStorageType[] {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'TenantRepository',
      methodName: 'findAll()',
      message: 'Not supported in TenantRepository.'
    });
    throw new Error('Method not implemented.');
  }

  clear(level = 0): void {
    const items = this.shellDAO.findAll({
      prefixKey: this.prefixKey
    }) as TenantDAOItemType[];
    const filteredItemKeys = [];
    items.forEach((t) => {
      if (
        t.key.startsWith(this.prefixKey) &&
        (!t.value?.level || t.value.level >= level)
      )
        filteredItemKeys.push(t.key);
    });
    this.shellDAO.deleteAll(filteredItemKeys);
  }
}
